<template>
  <div class="c-tabs">
    <div class="c-tabs__inner">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'tabs',
};
</script>

<style lang="scss">
.c-tabs {
  display: block;
  margin-bottom: 1em;
  position: relative;
  clear: both;

  &__inner {
    width: 100%;
    overflow-x: auto;
    white-space: nowrap;
    height: 52px;
    padding-left: 35%;
    padding-right: 35%;
  }

  &::after,
  &::before {
    content: "";
    position: absolute;
    top: 0;
    bottom: 0;
    width: 50px;
    pointer-events: none;
  }

  &::after {
    right: 0;
    background: linear-gradient(
      270deg,
      tint($colour-nhs-pale-grey, 60) 24.05%,
      rgba(243, 246, 246, 0) 100%
    );
  }
  &::before {
    left: 0;
    background: linear-gradient(
      270deg,
      rgba(243, 246, 246, 0),
      tint($colour-nhs-pale-grey, 60) 127.85% 100%
    );
  }

  @media screen and (min-width: 1024px) {
    margin-bottom: 2em;
    border-bottom: 2px solid #dfe4eb;

    &__inner {
      padding-left: 0;
      padding-right: 0;
      overflow: visible;
      height: auto;
    }

    &::after,
    &::before {
      content: none;
    }
  }
}
</style>
